import SelectInput from "components/inputs/selectInput"
import TextInput from "components/inputs/textInput"
import ToggleInput from "@/components/inputs/toggleInput"
import { useTranslation } from "react-i18next"
import { CustomersSortBy } from "@/hooks/useCustomers"
import { SortDirection } from "@/types"
import Collapse from "@/components/collapse/Collapse"
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'
import InputGroup from "@/components/inputs/InputGroup"

interface CustomerFilterProps {
    filterQuery: string
    setFilterQuery: (query: string) => void
    sortBy: CustomersSortBy
    setSortBy: React.Dispatch<React.SetStateAction<CustomersSortBy>>
    sortDirection: SortDirection
    setSortDirection: React.Dispatch<React.SetStateAction<SortDirection>>
    allowedSortBy: string[]
    displayDeleted: boolean
    setDisplayDeleted: (val: boolean) => void
    viewMode?: any // Optional for now
    setViewMode?: (mode: any) => void // Optional for now
}

const CustomerFilter: React.FC<CustomerFilterProps> = ({
    filterQuery,
    setFilterQuery,
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
    allowedSortBy,
    displayDeleted,
    setDisplayDeleted
}) => {
    const { t } = useTranslation()

    return (
        <div className="flex flex-col gap-y-4">
            <Collapse textOpen={t(`labelHideFilters`)} textClosed={t(`labelShowFilters`)} icon={<FilterIcon />}>
                <TextInput
                    label={t("labelFilterKeywords")}
                    value={filterQuery}
                    onChange={e => setFilterQuery(e.target.value)}
                />
                <InputGroup>
                    <SelectInput
                        label={t("labelSortBy")}
                        value={sortBy}
                        onChange={e => setSortBy(e.target.value as CustomersSortBy)}
                    >
                        {allowedSortBy.map(field => (
                            <option key={field} value={field}>{t(`column${field.charAt(0).toUpperCase() + field.slice(1)}`)}</option>
                        ))}
                    </SelectInput>
                    <SelectInput
                        label={t("labelSortDirection")}
                        value={sortDirection}
                        onChange={e => setSortDirection(e.target.value as SortDirection)}
                    >
                        <option value="asc">{t("sortAscending")}</option>
                        <option value="desc">{t("sortDescending")}</option>
                    </SelectInput>
                </InputGroup>
                <ToggleInput 
                    label={t("labelDisplayDeleted")} 
                    checked={displayDeleted} 
                    onChange={e => setDisplayDeleted(e.target.checked)} 
                />
            </Collapse>
        </div>
    )
}

export default CustomerFilter
